import { api } from './api.environment';
import { auth } from './auth.environment';
import { authentication } from './authentication.environment';
import { chimeraApi } from './chimera-api.environment';
import { dataMartApi } from './data-mart.environment';
import { hydra } from './hydra.environment';
import { icd10CodeSearch } from './icd10-code-search.environment';
import { newRelic } from './new-relic.environment';
import { pendo } from './pendo.environment';
import { workflowApi } from './workflow-api.environment';

export const common = {
  api,
  auth,
  authentication,
  chimeraApi,
  dataMartApi,
  hydra,
  icd10CodeSearch,
  newRelic,
  pendo,
  workflowApi,
};
